'use strict';

var SidebarThemeService = function ($window) {
    var defaultTheme = 'dark';
    var storageKeyPrefix = 'startdate.sidebarTheme.';
    var themeClasses = [
        'sidebar-theme-dark',
        'sidebar-theme-light',
        'sidebar-theme-blue',
        'sidebar-theme-teal',
        'sidebar-theme-aubergine',
        'sidebar-theme-charcoal',
        'sidebar-theme-slate',
        'sidebar-theme-graphite',
        'sidebar-theme-soft-gray',
        'sidebar-theme-classic'
    ];
    var themes = [
        {id: 'dark', labelKey: 'SidebarThemeDark'},
        {id: 'light', labelKey: 'SidebarThemeLight'},
        {id: 'charcoal', labelKey: 'SidebarThemeCharcoal'},
        {id: 'soft-gray', labelKey: 'SidebarThemeSoftGray'},
        {id: 'classic', labelKey: 'SidebarThemeClassic'}
    ];

    function isValidTheme(theme) {
        return themes.some(function (option) {
            return option.id === theme;
        });
    }

    function getStorageKey(userId) {
        return storageKeyPrefix + (userId || 'current');
    }

    this.options = themes;

    this.get = function (userId) {
        var savedTheme;

        try {
            savedTheme = $window.localStorage.getItem(getStorageKey(userId));
            if ('blue' === savedTheme || 'teal' === savedTheme || 'aubergine' === savedTheme ||
                'slate' === savedTheme || 'graphite' === savedTheme) {
                savedTheme = 'charcoal';
                $window.localStorage.setItem(getStorageKey(userId), savedTheme);
            }
        } catch (error) {
            savedTheme = null;
        }

        return isValidTheme(savedTheme) ? savedTheme : defaultTheme;
    };

    this.apply = function (theme) {
        var selectedTheme = isValidTheme(theme) ? theme : defaultTheme;
        var body = angular.element($window.document.body);

        themeClasses.forEach(function (themeClass) {
            body.removeClass(themeClass);
        });
        body.addClass('sidebar-theme-' + selectedTheme);

        return selectedTheme;
    };

    this.load = function (userId) {
        return this.apply(this.get(userId));
    };

    this.set = function (userId, theme) {
        var selectedTheme = this.apply(theme);

        try {
            $window.localStorage.setItem(getStorageKey(userId), selectedTheme);
        } catch (error) {
            // The theme still applies for this page when browser storage is unavailable.
        }

        return selectedTheme;
    };
};

SidebarThemeService.$inject = ['$window'];

module.exports = SidebarThemeService;
